import { BookOpen, Home, Search, TrendingUp } from 'lucide-react'

interface PublicTabNavigationProps {
  activeTab: string
  onTabChange: (tab: string) => void
}

const tabs = [
  { id: 'home', label: 'Home', icon: Home },
  { id: 'agents', label: 'Find Agent', icon: Search },
  { id: 'market', label: 'Market', icon: TrendingUp },
  { id: 'guides', label: 'Guides', icon: BookOpen },
]

export function PublicTabNavigation({ activeTab, onTabChange }: PublicTabNavigationProps) {
  return (
    <nav className="tab-bar">
      <div className="flex items-center justify-around py-2">
        {tabs.map((tab) => {
          const Icon = tab.icon
          const isActive = activeTab === tab.id

          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`flex flex-col items-center justify-center gap-1 px-3 py-1.5 min-w-[64px] transition-colors ${
                isActive ? 'text-primary' : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              <Icon className={`w-5 h-5 ${isActive ? 'stroke-[2.5px]' : ''}`} />
              <span className={`text-xs ${isActive ? 'font-semibold' : 'font-medium'}`}>
                {tab.label}
              </span>
            </button>
          )
        })}
      </div>
    </nav>
  )
}
